import * as React from "react";
import { connect } from "react-redux";
import selectorsToProps from "src/utils/selectorsToProps";
// import AppPicker from "./AppPicker";
import Help from "./Help";
import Menu from "./Menu";
import Preferences from "./Preferences";
import QUIQspreadLogo from "./QUIQspread.svg";
import { showUserPreferences } from "./selector";
import "./TopNav.scss";

const Title = () => {
  return (
    <div className="TopNav__logo-container">
      <img src={QUIQspreadLogo} className="TopNav__logo" />
      QUIQSpread<sup className="TopNav__logo-sup">TM</sup>
    </div>
  );
};

interface TopNavProps {
  showUserMenu: boolean;
  showPreferences?: boolean;
}

class TopNav extends React.Component<TopNavProps> {
  public render() {
    return (
      <div className="TopNav">
        <Title />
        <div className="TopNav__right">
          <Help />
          {/* Will be implemented after SSO integration */}
          {/* <AppPicker /> */}
          {this.props.showUserMenu && <Menu />}
          {this.props.showUserMenu && this.props.showPreferences && (
            <Preferences />
          )}
        </div>
      </div>
    );
  }
}

// export default TopNav;

export default connect(
  selectorsToProps({
    showPreferences: showUserPreferences
  })
)(TopNav);



// WEBPACK FOOTER //
// ./src/topNav/TopNav.tsx